webpackJsonp([5],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);



var Service = function Service(resolve) {
  return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(25)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Scene = function Scene(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(24)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Flow = function Flow(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(23)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ApiDoc = function ApiDoc(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(22)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  routes: [{
    path: '/',
    name: 'Service',
    component: Service
  }, {
    path: '/Scene',
    name: 'Scene',
    component: Scene
  }, {
    path: '/Flow/:anchor?',
    name: 'Flow',
    component: Flow
  }, {
    path: '/ApiDoc',
    redirect: '/ApiDoc/fastIntro',
    name: 'ApiDoc',
    component: ApiDoc,
    children: [{
      path: 'fastIntro',
      name: 'fastIntro',
      component: ApiDoc
    }, {
      path: 'fast',
      name: 'fast',
      component: ApiDoc
    }, {
      path: 'payFastOrder',
      name: 'payFastOrder',
      component: ApiDoc
    }, {
      path: 'fastOrderDetail',
      name: 'fastOrderDetail',
      component: ApiDoc
    }, {
      path: 'cancelFastOrder',
      name: 'cancelFastOrder',
      component: ApiDoc
    }, {
      path: 'fastModify',
      name: 'fastModify',
      component: ApiDoc
    }, {
      path: 'fileIntro',
      name: 'fileIntro',
      component: ApiDoc
    }, {
      path: 'uploadFile',
      name: 'uploadFile',
      component: ApiDoc
    }, {
      path: 'file',
      name: 'file',
      component: ApiDoc
    }, {
      path: 'priceNotice',
      name: 'priceNotice',
      component: ApiDoc
    }, {
      path: 'chargeOrder',
      name: 'chargeOrder',
      component: ApiDoc
    }, {
      path: 'searchOrder',
      name: 'searchOrder',
      component: ApiDoc
    }, {
      path: 'cancelOrder',
      name: 'cancelOrder',
      component: ApiDoc
    }, {
      path: 'searchResult',
      name: 'searchResult',
      component: ApiDoc
    }, {
      path: 'fileUpdate',
      name: 'fileUpdate',
      component: ApiDoc
    }, {
      path: 'auth',
      name: 'auth',
      component: ApiDoc
    }, {
      path: 'accessToken',
      name: 'accessToken',
      component: ApiDoc
    }, {
      path: 'plugin',
      name: 'plugin',
      component: ApiDoc
    }, {
      path: 'orderStatus',
      name: 'orderStatus',
      component: ApiDoc
    }, {
      path: 'interfaceCode',
      name: 'interfaceCode',
      component: ApiDoc
    }, {
      path: 'notify',
      name: 'notify',
      component: ApiDoc
    }]
  }, {
    path: '',
    component: Service
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  linkActiveClass: 'nav-router-link-active'
}));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(9)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(15),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  data: {
    currentRoute: window.location.pathname
  }
});
window.addEventListener('popstate', function () {
  console.log('popstate');
  app.currentRoute = window.location.pathname;
  console.log(currentRoute);
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_style_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GlobalNav__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GlobalNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_GlobalNav__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: {
    GlobalNav: __WEBPACK_IMPORTED_MODULE_1__components_GlobalNav___default.a
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GlobalNav',
  mounted: function mounted() {
    window.addEventListener('scroll', function () {
      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      var nav = document.getElementById('NavCon');
      if (scrollTop > 68) {
        nav.classList.add('fixed-nav');
      } else {
        nav.classList.remove('fixed-nav');
      }
    });
  }
});

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(10)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(16),
  /* scopeId */
  "data-v-c79fd2ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('global-nav'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-con",
    attrs: {
      "id": "NavCon"
    }
  }, [_c('div', {
    staticClass: "nav",
    attrs: {
      "id": "Nav"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Service'
      },
      "active-class": "nav-router-link-active",
      "exact": ""
    }
  }, [_vm._v("服务介绍")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Scene'
      },
      "active-class": "nav-router-link-active"
    }
  }, [_vm._v("使用场景")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Flow'
      },
      "active-class": "nav-router-link-active"
    }
  }, [_vm._v("接入流程")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ApiDoc'
      },
      "active-class": "nav-router-link-active"
    }
  }, [_vm._v("API文档")])], 1), _vm._v(" "), _c('li', {
    staticClass: "contact-us"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Flow',
        params: {
          anchor: 'contact'
        }
      },
      "active-class": "nav-router-link-none"
    }
  }, [_vm._v("立即合作")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('div', {
    staticClass: "logo"
  })])
}]}

/***/ })
],[5]);


// WEBPACK FOOTER //
// static/js/app.46029202a0ff09f52322.js